
import { getUserViewOptions } from '../api.js'

import schoolYear from './schoolYear.js'
import building from './building.js'
import district from './district.js'
import partition from './partition.js'
import vendor from './vendor.js'

const _vars = {
  promise: undefined,
}

function getOptionsFromServer(options) {
  if (_vars.promise === undefined) {
    _vars.promise = getUserViewOptions(options)
      .then(response => {
        let data = response.data

        schoolYear.populate(data.schoolYear)
        vendor.populate(data.vendor)
        district.populate(data.district)
        partition.populate(data.partition)
        building.populate(data.building)
        return data
      })
  }
  return _vars.promise
}

// async function getAsync(id, cachePath) {
//   let data = await cache.checkGetMiss(cachePath, () => {
//     return getOptionsFromServer()
//       .then(() => {
//         let allData = cache.get(...cachePath)
//         return allData.find(elem => elem.id === id)
//       })
//   })

//   return data
// }

export default {
  getOptionsFromServer
}
